import React, { useState,useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {ButtonsColor, fontFamilyall, PageBackgroundColor, TextColor} from "../../UtilColorPalate/UtilColorPalate";
import { ChangePasswordApi } from "../../Utility/UtilApi/UtilApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

function ChangePasswordForm ({ isOpen, onClose,handleSnackbarClick ,setToastmessage,setToastColor}) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword,setConfirmPassword] = useState("");
  const [pwdFocus, setPwdFocus] = useState(false);
  const [lowercaseValid, setLowercaseValid] = useState(false);
  const [uppercaseValid, setUppercaseValid] = useState(false);
  const [digitValid, setDigitValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [lengthValid, setLengthValid] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
 


  useEffect(() => {
    setValidPwd(PWD_REGEX.test(newPassword));
  }, [newPassword]);


  async function handleChangePassword(){

   
   let data =  {
          password : oldPassword,
          newpassword : newPassword,        
        
          }
          if (!newPassword || !confirmPassword || !validPwd) {
            setToastmessage("Please enter the valid password");
            setToastColor(false);
            handleSnackbarClick();
            return;
          } else { 
          if(newPassword === confirmPassword){
            ChangePasswordApi(data).then((response)=>{ 

                console.log("response", response);
                
              setToastColor(response.data.success);
              setToastmessage(response.data.message);
              handleSnackbarClick();
              onClose();
              setConfirmPassword('');
              setNewPassword('');
              setOldPassword("");
              setPwdFocus(false);

            }).catch((err)=>{
              console.log(err)
              setToastColor(err?.response?.data?.success);
              setToastmessage(err?.response?.data?.message);
              handleSnackbarClick();
            })
           
          }
          else if(newPassword !== confirmPassword){
            setToastmessage('New password and confirm password is invalid');
            setToastColor(false);
            handleSnackbarClick();
          }
        }
  }

  const handleValidatePassword = (newPassword) => {
    setNewPassword(newPassword);
    setLowercaseValid(/[a-z]/.test(newPassword));
    setUppercaseValid(/[A-Z]/.test(newPassword));
    setDigitValid(/[0-9]/.test(newPassword));
    setSpecialCharValid(/[!@#$%]/.test(newPassword));
    setLengthValid(newPassword.length >= 8 && newPassword.length <= 24);
  };

  

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor:PageBackgroundColor,
          boxShadow: 24,
          borderRadius:"5px",
          p: 2,
        }}
      >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{
              padding: "4px",
              paddingLeft: "10px",
              borderRadius: "5px",
              fontFamily: fontFamilyall,
              color: TextColor,
            }}
            id="modal-modal-title"
          >
            Change Password
          </Typography>
          <IconButton onClick={() => { 
    setPwdFocus(false); 
    onClose(); 
}}>
    <CloseIcon style={{ fontSize: "16px", color: TextColor }} />
</IconButton>

        </div>
            <div >
            <TextField
           
          label="Old Password"
          type="password"
          autoComplete="new-password"
          onChange={(e) => setOldPassword(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{ style: { fontFamily: fontFamilyall,color: TextColor}}}
        />
        <TextField
          label="New Password"
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => handleValidatePassword(e.target.value)}
          // onChange={(e) => setNewPassword(e.target.value)}
          fullWidth
          margin="normal"          
          onFocus={() => setPwdFocus(true)}
          InputLabelProps={{ style: { fontFamily: fontFamilyall,color: TextColor}}}
        />
        <TextField
          label="Confirm Password"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{ style: { fontFamily: fontFamilyall,color: TextColor}}}
        />
        </div>
        <br />
        {pwdFocus && (
            <p
            id="pwdnote"
            className={
              pwdFocus && newPassword && !validPwd ? "instructions" : "offscreen"
            }
          >
            {/* <FontAwesomeIcon icon={faCheckCircle} /> */}
            <FontAwesomeIcon
              icon={lowercaseValid ? faCheckCircle : faInfoCircle}
              style={{ color: lowercaseValid ? "green" : "red" }}
            />
            <span style={{ color: lowercaseValid ? "green" : "red" }}>
              {" "}
              Requires at least one lowercase letter.
            </span>
            <br />
            <FontAwesomeIcon
              icon={uppercaseValid ? faCheckCircle : faInfoCircle}
              style={{ color: uppercaseValid ? "green" : "red" }}
            />
            <span style={{ color: uppercaseValid ? "green" : "red" }}>
              Requires at least one uppercase letter.
            </span>
            <br />
            <FontAwesomeIcon
              icon={digitValid ? faCheckCircle : faInfoCircle}
              style={{ color: digitValid ? "green" : "red" }}
            />
            <span style={{ color: digitValid ? "green" : "red" }}>
              Requires at least one digit.
            </span>
            <br />
            <FontAwesomeIcon
              icon={specialCharValid ? faCheckCircle : faInfoCircle}
              style={{ color: specialCharValid ? "green" : "red" }}
            />
            <span style={{ color: specialCharValid ? "green" : "red" }}>
              {" "}
              Requires at least one special character (one of !@#$%).
            </span>
            <br />
            <FontAwesomeIcon
              icon={lengthValid ? faCheckCircle : faInfoCircle}
              style={{ color: lengthValid ? "green" : "red" }}
            />
            <span style={{ color: lengthValid ? "green" : "red" }}>
              {" "}
              Requires a total length between 8 and 24 characters.
            </span>
            <br />
          </p>
        )}

        
        <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <Button
                    sx={{ ml: 1 }}
                    variant="contained"
                    style={{
                      backgroundColor: ButtonsColor,
                      fontFamily: fontFamilyall,
                      color: TextColor
                    }}
                    onClick={handleChangePassword}
                  >
                    Save
                  </Button>
                  <Button onClick={onClose} sx={{ ml: 1 }} variant="outlined" color="error">
                    Cancel
                  </Button>
                </div>
      </Box>
    </Modal>
  );
};

export default ChangePasswordForm;
